module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "hour"
  }, [_vm._v("\n    " + _vm._s(_vm.time) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.trainer.firstName))]), _vm._v(" "), _c('a', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.userPicture,
      "alt": "User Picture"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-495cc764"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/UserInfo.vue
// module id = 1673
// module chunks = 1